import { createSelector } from 'reselect';

// TODO (josh) : this key should come from a constant
const getFeedbacks = state => state.feedbacks;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getFeedbackUuidParam = createParameterSelector(params => params.feedbackUuid);
const getReceiverIdParam = createParameterSelector(params => params.receiverId);
const getCreatorIdParam = createParameterSelector(params => params.creatorId);
const getTemplateTypeParam = createParameterSelector(params => params.templateType);

export const getFeedbackByTypeAndReceiverId = createSelector(
  [getFeedbacks, getReceiverIdParam, getTemplateTypeParam],
  (feedbacks, receiverId, type) => {
    return Object.values(feedbacks).filter(
      feedback => feedback.templateType === type && feedback.receiverId === receiverId
    );
  }
);

export const getFeedbackByTypeAndCreatorId = createSelector(
  [getFeedbacks, getCreatorIdParam, getTemplateTypeParam],
  (feedbacks, creatorId, type) => {
    return Object.values(feedbacks).filter(
      feedback => feedback.templateType === type && feedback.creatorId === creatorId
    );
  }
);

export const getFeedbackByUuidV2 = createSelector([getFeedbacks, getFeedbackUuidParam], (feedbacks, uuid) => {
  return feedbacks[uuid];
});

// TODO: (josh) These selectors below need to be refactored
//
export const getFeedbackByUuid = uuid => state => state.feedbacks[uuid];

export const getFeedbacksByWorkspaceUuid = workspaceUuid => state =>
  Object.values(state.feedbacks).filter(item => item.workspaceUuid === workspaceUuid);

export const getFeedbackDrafts = state => Object.values(state.feedbacks).filter(item => item.isDraft);

export const getDraftFeedbackByWorkspaceUuid = workspaceUuid => state => {
  const currentUserId = state.user.id;
  const workspaceFeedbacks = getFeedbacksByWorkspaceUuid(workspaceUuid)(state);
  return workspaceFeedbacks.find(({ isDraft, creatorId }) => isDraft && creatorId === currentUserId);
};
